import { render, staticRenderFns } from "./Moble.vue?vue&type=template&id=1c210f0b&scoped=true&"
import script from "./Moble.vue?vue&type=script&lang=js&"
export * from "./Moble.vue?vue&type=script&lang=js&"
import style0 from "./Moble.vue?vue&type=style&index=0&id=1c210f0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c210f0b",
  null
  
)

export default component.exports